import CommonModal from "@/components/ui/CommonModal";
import ImgPreview from "./img-preview";
import styles from "./ContractCheck.module.less";
import { CheckResult } from "./CheckResult";
import { useState } from "react";
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from "@/components/ui/buttons/PrimaryButton";
import { useModalBehavior } from "@/hooks/behaviors";
import { type FormInstance } from "antd";
import type { PurchaseContractFormValues } from "../../type";
import { notifyWarning } from "@/utils/notification";
import {
  useCheckResultMutation,
  useUploadResultMutation,
} from "./hooks/useCheckResult";
import type { ContractCheckResult } from "./hooks/useCheckResult";
import { useTranslation } from "react-i18next";

type ContractCheckProps = {
  form?: FormInstance<PurchaseContractFormValues>;
};

export function ContractCheck({ form }: ContractCheckProps) {
  const { t } = useTranslation("contractManagement");
  const [checkResult, setCheckResult] = useState<ContractCheckResult | null>(
    null,
  );

  const urlList = checkResult?.previewLink?.split("|") || [];

  const [pageState, setPageState] = useState<{ pageNo: number }>({ pageNo: 1 });
  const uploadResultMutation = useUploadResultMutation();
  const checkResultMutation = useCheckResultMutation();

  const { open, openModal, closeModal } = useModalBehavior();

  const handleCheck = () => {
    if (!form) return;
    const { contractFiles, signedContracts } = form.getFieldsValue();

    const contractFileUrl = contractFiles?.[0]?.url;
    const signedContractFileUrl = signedContracts?.[0]?.url;

    let checkUrl = contractFileUrl;

    if (!checkUrl) {
      return notifyWarning(t("未上传合同：查询不到目标文件，请先上传合同"));
    }

    if (signedContractFileUrl) {
      checkUrl = signedContractFileUrl;
    }

    // checkUrl =
    //   "https://winwaywebtest.tos-cn-guangzhou.volces.com/AI中台-内容合规审查/合同原件-通力电梯合同_1767603327000.pdf";

    checkResultMutation.mutate(checkUrl, {
      onSuccess: (data) => {
        if (data.data.code === 0) {
          if (!data.data.data) {
            uploadResultMutation.mutate(checkUrl!, {
              onSuccess(data) {
                if (data.data.code === 0) {
                  notifyWarning(t("合同正在审核，请耐心等待"));
                } else {
                  notifyWarning(data.data?.msg || t("合同审核失败"));
                }
              },
            });
            return;
          }

          if (data.data.data.id && !data.data.data.detectionResult) {
            return notifyWarning(t("合同正在审核，请耐心等待"));
          }

          setCheckResult(data.data.data);
          openModal();
        } else {
          notifyWarning(data.data?.msg || t("合同审核失败"));
        }
      },
    });
  };

  return (
    <>
      <PrimaryButton onClick={handleCheck}>{t("查看AI审核结果")}</PrimaryButton>

      <CommonModal
        title={t("合同审核")}
        width={"90%"}
        centered
        open={open}
        onCancel={closeModal}
        footer={
          <PrimaryOutlineButton onClick={closeModal}>
            {t("关闭")}
          </PrimaryOutlineButton>
        }
      >
        <div className={styles.container}>
          <div className={styles.leftPanel}>
            <ImgPreview list={urlList || []} pageState={pageState} />
          </div>
          <div className={styles.rightPanel}>
            <CheckResult
              result={checkResult?.detectionResult || "{}"}
              urlList={urlList}
              onScrollTo={(pageNo: number) => {
                setPageState({ pageNo });
              }}
            />
          </div>
        </div>
      </CommonModal>
    </>
  );
}
